import { wrapReducer } from "@client/content/lib/helper";
import {
  Actions as DetailActions,
  type LessonEventBeginActionData,
  type LessonEventSuccessActionData
} from "@client/content/modules/CourseDetail/actions";
import { updateItem } from "@client/lib/array";
import { Status } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import { reducerDetail } from "../CourseDetail/reducer";
import { Actions, type InitBeginActionData, type InitSuccessActionData, type SetSearchTextActionData } from "./actions";
import { type CourseList } from "./types";

const reducer = (state: CourseList.AppState = defaultState, action: ReduxAction<any>): CourseList.AppState => {
  switch (action.type) {
    case Actions.InitBegin: {
      const args = action.params as InitBeginActionData;
      return {
        ...state,
        status: args.isReload ? state.status : Status.Loading
      };
    }
    case Actions.InitFailure: {
      return {
        ...state,
        status: Status.Failed
      };
    }
    case Actions.InitSuccess: {
      const { activeCourse, activeLesson, courses: availableCourses } = action.data as InitSuccessActionData;
      return {
        ...state,
        activeCourseId: null,
        activeCourse,
        availableCourses: availableCourses ?? [],
        status: Status.Ready,
        lessonDetail: activeLesson
          ? {
              [activeLesson.id]: {
                ...activeLesson,
                error: null,
                status: "ready"
              }
            }
          : {}
      };
    }

    case Actions.SetSearchText: {
      const { searchText } = action.data as SetSearchTextActionData;
      return {
        ...state,
        searchText
      };
    }

    default:
      return reducerDetail(state, action);
  }
};

export const defaultState: CourseList.AppState = {
  activeCourse: null,
  activeCourseId: null,
  availableCourses: [],
  lessonDetail: {},
  error: null,
  id: "",
  searchText: null,
  status: Status.None
};

export const previewState: CourseList.AppState = {
  activeCourse: {
    activeLessonId: null,
    activeModuleId: null,
    allFaq: [],
    course: {
      completedLessonCount: 0,
      id: "dummy",
      isEnrolled: true,
      isMembership: false,
      name: "Dummy",
      portalId: "",
      registerPagePermalink: "/",
      thumbnailMediaId: null,
      totalLessonCount: 10,
      mediaSourceId: null
    },
    lessons: [],
    modules: []
  },
  activeCourseId: null,
  availableCourses: [],
  lessonDetail: {},
  error: null,
  id: "",
  searchText: null,
  status: Status.Ready
};
export default wrapReducer({
  defaultState,
  reducer,
  addon: (state: CourseList.AppState, action: ReduxAction<any>): CourseList.AppState => {
    switch (action.type) {
      case DetailActions.LessonEventSuccess: {
        // hook into ANY detail module to properly set progress
        const { courseId } = action.params as LessonEventBeginActionData;
        const { lessons } = action.data as LessonEventSuccessActionData;
        return {
          ...state,
          availableCourses: updateItem(state.availableCourses, courseId, (x) => ({
            ...x,
            completedLessonCount: lessons.filter((y) => !y.isBonus && y.isComplete).length,
            totalLessonCount: lessons.filter((y) => !y.isBonus).length
          }))
        };
      }
      default:
        return state;
    }
  },
  previewState
});
